import React from 'react';
import Menu from '../Menu';
import { menuLinks, sections, bestPracticesDefault } from '../constants'
import ils_18 from './../images/assets/ils_18.svg';

import ServiceContent from './ServiceContent';

const title = 'Advanced Computer Vision & Agentic Visual Intelligence'
const description = 'Computer Vision has evolved beyond pattern recognition into intelligent agentic systems. We leverage state-of-the-art pre-trained models (YOLO, Vision Transformers, R-CNN) and custom fine-tuning for specialized use cases. Our expertise includes one-shot and few-shot learning for rapid deployment, real-time action detection, and custom video annotation tooling for long-form content. Combined with agentic workflows, our computer vision solutions can autonomously monitor, analyze, and respond to visual data in real-time.'

const useCases = [
	'One-shot object detection for new product categories with minimal training data',
	'Real-time action recognition and classification for sports, fitness, and security',
	'Agentic video monitoring systems with automated alert generation',
	'Custom dataset creation and video annotation for long-form content',
	'Temporal action segmentation and analysis in extended videos',
	'Intelligent video quality analysis and content moderation',
	'Track fitness movements with real-time AI-powered feedback',
	'Automated video cataloging with context-aware tagging'
]
const bestPractices = bestPracticesDefault.concat([
	'Custom model fine-tuning on domain-specific datasets (YOLO, R-CNN, Vision Transformers)',
	'One-shot and few-shot learning for rapid model deployment',
	'GPU-accelerated processing for real-time inference',
	'Agentic monitoring systems with autonomous decision-making',
	'Custom video labeling tooling for specialized annotation workflows'
])

const faqs = [
	{
		question: "What is one-shot object detection and when should I use it?",
		answer: "One-shot object detection is a computer vision technique that can identify new object categories with just a single training example. It is ideal when you need to detect new product categories, rare objects, or specialized items where collecting large training datasets is impractical. CaptainMe AI uses pre-trained models like YOLO and Vision Transformers with custom fine-tuning for one-shot deployment."
	},
	{
		question: "How does AI-powered exercise detection work?",
		answer: "AI-powered exercise detection uses computer vision models for real-time pose estimation and action recognition. The system analyzes video feeds to identify body positions, track movements across frames, and classify exercises like squats, biceps curls, and overhead presses. It works from multiple camera angles (0 to 180 degrees) and provides real-time feedback on form and repetition counting."
	},
	{
		question: "What is agentic video monitoring?",
		answer: "Agentic video monitoring combines computer vision with autonomous AI agents that can independently monitor, analyze, and respond to visual data in real-time. Unlike traditional video analytics that only detect events, agentic systems can make decisions, generate alerts, and trigger automated responses without human intervention."
	}
]

function ServicesComputerVision() {
	return (
		<React.Fragment>
			< Menu />

			<ServiceContent
				pageTitle='Computer Vision & Agentic Visual Intelligence'
				title={title}
				description={description}
				useCases={useCases}
				bestPractices={bestPractices}
				img={ils_18}
				techDescription=''
				breadCrumpMenu={sections.services.computerVision.title}
				currentMenuPage={menuLinks.servicesComputerVision}
				faqs={faqs}
			/>

		</React.Fragment>
	)
}

export default ServicesComputerVision;
